import moment from 'moment'
import {FC, useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import {InputDate} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {useCentral} from '../../../../../../hooks/useCentral'
import {SelectOption} from '../../../../../../models/utility.model'
import {formatDate} from '../../../../../../util/dates'
import {useCentralServices} from '../../../../../hoteleria/hooks/useCentralServices'
import Swal from 'sweetalert2'
import {
  completeStaysService,
  getParameterByIdService,
  recalculateCostsService,
} from '../../../../services/parameter.service'
import {getSnackBarToast} from '../../../../../../util/snackBar'
import {CheckWrapper} from '../../../../../../components/UI/Form/Input'
import useTableForMaster from '../../../../hooks/useTableForMaster'
const hours: SelectOption[] = [
  {value: '00:00', label: '00:00 AM'},
  {value: '01:00', label: '01:00 AM'},
  {value: '02:00', label: '02:00 AM'},
  {value: '03:00', label: '03:00 AM'},
  {value: '04:00', label: '04:00 AM'},
  {value: '05:00', label: '05:00 AM'},
  {value: '06:00', label: '06:00 AM'},
  {value: '07:00', label: '07:00 AM'},
  {value: '08:00', label: '08:00 AM'},
  {value: '09:00', label: '09:00 AM'},
  {value: '10:00', label: '10:00 AM'},
  {value: '11:00', label: '11:00 AM'},
  {value: '12:00', label: '12:00 PM'},
  {value: '13:00', label: '13:00 PM'},
  {value: '14:00', label: '14:00 PM'},
  {value: '15:00', label: '15:00 PM'},
  {value: '16:00', label: '16:00 PM'},
  {value: '17:00', label: '17:00 PM'},
  {value: '18:00', label: '18:00 PM'},
  {value: '19:00', label: '19:00 PM'},
  {value: '20:00', label: '20:00 PM'},
  {value: '21:00', label: '21:00 PM'},
  {value: '22:00', label: '22:00 PM'},
  {value: '23:00', label: '23:00 PM'},
]

const Index: FC = () => {
  const {
    setError,
    register,
    formState: {errors},
    control,
    setValue,
    watch,
  } = useFormContext()
  const {currentTabItem} = useCentral()
  const {valorations, getValorationList} = useTableForMaster()
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [sites, setSites] = useState<SelectOption[]>([])
  const [camps, setCamps] = useState<SelectOption[]>([])
  const [moneda, setMoneda] = useState<SelectOption[]>([])

  const [parameterStatus, setParameterStatus] = useState<SelectOption[]>([])
  const [showHParams, setShowHParams] = useState<boolean>(false)
  const [stayTypes, setStayTypes] = useState<SelectOption[]>([])
  const [loadingRecalculate, setLoadingRecalculate] = useState<boolean>(false)
  const [loadingCompleteStays, setLoadingCompleteStays] = useState<boolean>(false)

  const [applications, setApplications] = useState<SelectOption[]>([])
  const [parameterUnidad, setParameterUnidad] = useState<SelectOption[]>([])
  const {
    getCompanies,
    getClients,
    getParametersStatus,
    getMoneda,
    getUnidadParameter,
    getApplications,
    getSites,
    getCamps,
    getMasterTable,
  } = useCentralServices()

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    setCompany(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    setClient(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    setSites(data)
  }

  const getCampsFn = async (id: string) => {
    const data = await getCamps({isCombo: true, siteId: id}, 1)
    const allData = [{value: '4EsB2NAAsDA=', label: 'TODOS'}, ...data]
    if (data.length === 2 && !currentTabItem.idToEdit) {
      setValue('CampamentoId', allData[1].value as string)
      setError('CampamentoId', {})
    }
    setCamps(allData)
  }

  const getApplicationsFn = async () => {
    const data = await getApplications()
    const filterData = data.filter(
      (item) =>
        item.label === 'Hotelería' || item.label === 'Lavandería' || item.label === 'Comedores',
    )
    setApplications(filterData)
  }

  const getParametersStatusFn = async () => {
    const data = await getParametersStatus()
    setParameterStatus(data)
  }

  const getMonedaFn = async () => {
    const data = await getMoneda()
    setMoneda(data)
  }

  const getUnidadParameterFn = async (aplicacion: string) => {
    const data = await getUnidadParameter()
    const filteredData = data.filter((item) => item.codigoPadre === aplicacion)
    setParameterUnidad(filteredData)
  }

  const getStayTypesFn = async () => {
    const data = await getMasterTable('TipoEstadia', true)
    setStayTypes(data)
  }

  const getClaimId = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getParameterByIdService(idToEdit as any)
        console.log(data)
        const {
          Id,
          CompaniaId,
          ClienteId,
          CampamentoId,
          FechaIni,
          FechaFin,
          MonedaId,
          UnidadParametrosId,
          AplicacionId,
          EstadoParametrosId,
          EstadoParametros_descripcion,
          SiteId,
          TipoEstadiaId,
          Aplicacion_descripcion,
          HoraCorte,
          ValorizacionId,
          ConCliente,
          ConCompania,
        } = data
        let CampamentoValue = CampamentoId === null ? '4EsB2NAAsDA=' : CampamentoId
        console.log('CampamentoValue => ', CampamentoValue)
        setValue('Id', Id)
        setValue('CompaniaId', CompaniaId)
        setValue('ClienteId', ClienteId)
        setValue('AplicacionId', AplicacionId)
        setValue('CampamentoId', CampamentoValue)
        setValue('SiteId', SiteId)
        setValue('FechaIni', formatDate(FechaIni))
        setValue('FechaFin', formatDate(FechaFin))
        setValue('MonedaId', MonedaId)
        setValue('UnidadParametrosId', UnidadParametrosId)
        setValue('EstadoParametrosId', EstadoParametrosId)
        setValue('EstadoParametros_descripcion', EstadoParametros_descripcion)
        setValue('Aplicacion_descripcion', Aplicacion_descripcion)
        setValue('ValorizacionId', ValorizacionId)
        setValue('ConCliente', ConCliente || false)
        setValue('ConCompania', ConCompania || false)
        getClientsFn(CompaniaId as any)
        getSitesFn(ClienteId as any)
        getCampsFn(SiteId as any)

        if (Aplicacion_descripcion === 'Hotelería') {
          getUnidadParameterFn('SoHot')
          setShowHParams(true)
          setValue('TipoEstadiaId', TipoEstadiaId)
          setValue('HoraCorte', HoraCorte)
        }
        if (Aplicacion_descripcion === 'Lavandería') {
          getUnidadParameterFn('SoLav')
        }
        if (Aplicacion_descripcion === 'Comedores') {
          getUnidadParameterFn('02')
        }
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getClaimId()
    }
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    if (currentTabItem.idToEdit && applications.length > 0) {
      const findValue = applications.find((item) => item.value === watch('AplicacionId')) as any
      getValorationList(findValue?.codNumero || '')
    }
  }, [currentTabItem.idToEdit, applications])

  useEffect(() => {
    getCompaniesFn()
    getMonedaFn()
    getApplicationsFn()
    getParametersStatusFn()
    getStayTypesFn()
    setValue('MonedaId', 'ciKCcDpM4AY=')
  }, [])

  let isDisabled = currentTabItem.idToEdit ? true : false
  let isDisabledStatus = watch('EstadoParametros_descripcion') !== 'INACTIVO' ? false : true

  const handleModuleChange = (val: any) => {
    let value = val ? val.value : ''
    getValorationList(val.codNumero)
    setValue('AplicacionId', value)
    setError('AplicacionId', {})
    setParameterUnidad([])
    setValue('ValorizacionId', '')
    setError('ValorizacionId', {})
    const hotId = applications.find((item) => item.label === 'Hotelería')?.value
    const lavId = applications.find((item) => item.label === 'Lavandería')?.value
    const comId = applications.find((item) => item.label === 'Comedores')?.value
    if (value === hotId) {
      getUnidadParameterFn('SoHot')
      setShowHParams(true)
      setValue('UnidadParametrosId', '')
    }
    if (value === lavId) {
      setShowHParams(false)
      getUnidadParameterFn('SoLav')
      setValue('UnidadParametrosId', '')
    }
    if (value === comId) {
      setShowHParams(false)
      getUnidadParameterFn('02')
      setValue('TipoEstadiaId', '')
      setValue('HoraCorte', '')
      setValue('UnidadParametrosId', '')
    }
  }

  const handleGetClientList = async (val: any) => {
    let value = val ? val.value : ''
    getClientsFn(value)
    setValue('CompaniaId', value)
    setError('CompaniaId', {})
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setSites([])
    setClient([])
  }

  const handleGetSiteList = async (val: any) => {
    let value = val ? val.value : ''
    getSitesFn(value)
    setValue('ClienteId', value)
    setError('ClienteId', {})
    setValue('SiteId', '')
    setSites([])
  }

  const handleGetCampList = async (val: any) => {
    let value = val ? val.value : ''
    getCampsFn(value)
    setValue('SiteId', value)
    setError('SiteId', {})
    setValue('CampamentoId', '')
    setCamps([])
  }

  const handleResetCosts = async () => {
    try {
      setLoadingRecalculate(true)
      const {data: response} = await recalculateCostsService(currentTabItem.idToEdit)
      if (!response.error) {
        getSnackBarToast('Se recalculo los costos con éxito', 'success')
        setLoadingRecalculate(false)
      } else {
        getSnackBarToast(response.message, 'error')
        setLoadingRecalculate(false)
      }
    } catch (error) {
      setLoadingRecalculate(false)
      getSnackBarToast('Hubo un error ', 'error')
      console.log(error)
    }
  }

  const handleCompleteStay = async () => {
    try {
      Swal.fire({
        title: '¿Estás seguro?',
        text: `Completaras las estadias`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, completar',
        confirmButtonColor: 'var(--kt-primary)',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoadingCompleteStays(true)
          try {
            const {data: response} = await completeStaysService(currentTabItem.idToEdit)
            if (!response.error) {
              getSnackBarToast('Se completaron las estadias con éxito', 'success')
              setLoadingCompleteStays(false)
            } else {
              getSnackBarToast(response.message, 'error')
              setLoadingCompleteStays(false)
            }
            setLoadingCompleteStays(false)
          } catch (error) {
            setLoadingCompleteStays(false)
            getSnackBarToast('Hubo un error ', 'error')
            console.log(error)
          }
          Swal.close()
        } else if (result.isDenied) {
        }
      })
    } catch (error) {
      setLoadingCompleteStays(false)
      getSnackBarToast('Hubo un error ', 'error')
      console.log(error)
    }
  }
  return (
    <div className='sdx_form card p-4 h-100'>
      {currentTabItem.editOnBottomPanel && (
        <div className='d-flex justify-content-end p-2 me-5'>
          {watch('Aplicacion_descripcion') === 'Hotelería' &&
            watch('EstadoParametros_descripcion') === 'ACTIVO' && (
              <div className='d-flex'>
                <button
                  type='button'
                  className='btn btn-success me-3 d-flex align-items-center'
                  onClick={handleCompleteStay}
                  disabled={loadingCompleteStays}
                >
                  {loadingCompleteStays && (
                    <div className='icon-container me-3'>
                      <i className='loader'></i>
                    </div>
                  )}
                  Completar Estadías
                </button>
                <button
                  type='button'
                  className='btn btn-success me-3 d-flex align-items-center'
                  onClick={handleResetCosts}
                  disabled={loadingRecalculate}
                >
                  {loadingRecalculate && (
                    <div className='icon-container me-3'>
                      <i className='loader'></i>
                    </div>
                  )}
                  Recalcular Costos
                </button>
              </div>
            )}
          {watch('EstadoParametros_descripcion') !== 'INACTIVO' && (
            <button
              type='submit'
              className='btn btn-success me-3 d-flex align-items-center'
              disabled={currentTabItem.loadingBottomPanelButton}
            >
              {currentTabItem.loadingBottomPanelButton && (
                <div className='icon-container me-3'>
                  <i className='loader'></i>
                </div>
              )}
              Guardar
            </button>
          )}
        </div>
      )}
      <h4>Datos de Parámetros</h4>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Compañía</label>
          <Select
            control={control}
            name='CompaniaId'
            data={compani}
            errors={errors}
            disabled={isDisabled}
            onChangeValue={handleGetClientList}
          />
        </div>

        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Cliente</label>
          <Select
            control={control}
            name='ClienteId'
            data={client}
            errors={errors}
            disabled={isDisabled}
            onChangeValue={handleGetSiteList}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Site</label>
          <Select
            control={control}
            name='SiteId'
            data={sites}
            errors={errors}
            onChangeValue={handleGetCampList}
            disabled={isDisabled}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Campamento</label>
          <Select
            control={control}
            name='CampamentoId'
            data={camps}
            errors={errors}
            disabled={isDisabled}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Fecha de Inicio:</label>
          <InputDate
            name='FechaIni'
            register={register}
            errors={errors}
            minValue='1900-01-01'
            defaultValue={moment().format('YYYY-MM-DD')}
            disabled={isDisabledStatus}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Fecha de Fin:</label>
          <InputDate
            name='FechaFin'
            register={register}
            errors={errors}
            minValue='1900-01-01'
            defaultValue={moment().format('YYYY-MM-DD')}
            disabled={isDisabledStatus}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Módulo</label>
          <Select
            control={control}
            name='AplicacionId'
            data={applications}
            errors={errors}
            onChangeValue={handleModuleChange}
            disabled={isDisabledStatus}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Tipo de Valorización</label>
          <Select
            control={control}
            name='ValorizacionId'
            data={valorations}
            errors={errors}
            disabled={isDisabledStatus}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Moneda</label>
          <Select
            control={control}
            name='MonedaId'
            data={moneda}
            errors={errors}
            disabled={isDisabledStatus}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Unidad</label>
          <Select
            control={control}
            name='UnidadParametrosId'
            data={parameterUnidad}
            errors={errors}
            disabled={isDisabledStatus}
          />
        </div>
        {showHParams && (
          <>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className='required'>Tipo de Estadía</label>
              <Select
                control={control}
                name='TipoEstadiaId'
                data={stayTypes}
                errors={errors}
                disabled={isDisabledStatus}
              />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className='required'>Hora de Corte</label>
              <Select
                control={control}
                name='HoraCorte'
                data={hours}
                errors={errors}
                disabled={isDisabledStatus}
              />
            </div>
          </>
        )}
        {currentTabItem.idToEdit && (
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <label className=''>Estado</label>
            <Select
              control={control}
              name='EstadoParametrosId'
              data={parameterStatus}
              errors={errors}
              disabled={isDisabledStatus}
            />
          </div>
        )}
      </div>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-2 d-flex align-items-center justify-content-start'>
          <CheckWrapper
            name='ConCliente'
            nameCheck='Cliente'
            className='h-100'
            disabled={isDisabledStatus}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-2 d-flex align-items-center'>
          <CheckWrapper
            name='ConCompania'
            nameCheck='Compañía'
            className='h-100'
            disabled={isDisabledStatus}
          />
        </div>
      </div>
    </div>
  )
}

export default Index
